import React from "react"; 
import {RadioButtonInput } from '../../components/FormInitiators';


const SrFixationForm4 = ({ formData, setFormData, onBack, onNext }) => {
  
  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
        <h3> सेवेतील राजा / सेवाखंड तपशील </h3>

        <label>
        सेवेत विनावेतन रजा आहे का ?
          </label>
          <label>
                <RadioButtonInput
                  value={formData.hasUnpaidLeave} 
                  onChange={handleInputChange}
                  name="hasUnpaidLeave"  
                  orientation="horizontal"  
                  options={[
                    { value: 'हो', label: 'हो' },
                    { value: 'नाही', label: 'नाही' }
                  ]}         
                />
            
        </label>

        <label>
        असल्यास विना वेतन रजा तपशील:
        <input type="text"  name="unpaidLeaveDetails" value={formData.unpaidLeaveDetails}  onChange={handleInputChange}/>
        </label>

        <label>
        सेवेत सेवाखंड आहे काय ?
        </label>
        <label>
                <RadioButtonInput
                  value={formData.hasServiceBreak} 
                  onChange={handleInputChange}
                  name="hasServiceBreak"  
                  orientation="horizontal"  
                  options={[
                    { value: 'हो', label: 'हो' },
                    { value: 'नाही', label: 'नाही' }
                  ]}         
                />
        </label>
     
        <label>
        असल्यास सेवाखंड तपशील:
        <input type="text"  name="serviceBreakDetails" value={formData.serviceBreakDetails}  onChange={handleInputChange}/>
        </label>

        <label>
        सेवाखंड क्षमापित केला आहे का ?
        </label>
        <label>
                <RadioButtonInput
                  value={formData.isServiceBreakCondoned} 
                  onChange={handleInputChange}
                  name="isServiceBreakCondoned"  
                  orientation="horizontal"  
                  options={[
                    { value: 'हो', label: 'हो' },
                    { value: 'नाही', label: 'नाही' },
                    { value: 'लागू नाही', label: 'लागू नाही' }
                  ]}         
                />
        </label>




      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default SrFixationForm4;
